import ApexChartsPackage from 'apexcharts';
import waitUntil from 'async-wait-until';
import { COLORS } from '@config';

/* global KTApp */

export default class DashboardApplicationStats {
  static selectorString() {
    return '.DashboardApplicationStats';
  }

  async render(node, props) {
    await waitUntil(() => !!KTApp.getSettings().colors);

    const options = {
      series: [
        {
          name: 'Anzahl',
          data: props.items.map(item => item.count),
        },
      ],
      chart: {
        type: 'bar',
        height: 200,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: ['50%'],
          borderRadius: 6,
        },
      },
      legend: {
        show: true,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: props.items.map(item => item.abbrevation),
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          rotate: -45,
          style: {
            colors: KTApp.getSettings().colors.gray['gray-500'],
            fontSize: '12px',
            fontFamily: KTApp.getSettings()['font-family'],
          },
        },
      },
      yaxis: {
        show: false,
        labels: {
          style: {
            colors: KTApp.getSettings().colors.gray['gray-500'],
            fontSize: '12px',
            fontFamily: KTApp.getSettings()['font-family'],
          },
        },
      },
      fill: {
        opacity: 1,
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        hover: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: '12px',
          fontFamily: KTApp.getSettings()['font-family'],
        },
        x: {
          formatter: function (val) {
            return props.items.find(item => item.abbrevation === val).label;
          },
        },
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      colors: [({ dataPointIndex }) => COLORS[props.items[dataPointIndex].color]],
      grid: {
        borderColor: KTApp.getSettings().colors.gray['gray-200'],
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
    };

    const chart = new ApexChartsPackage(node, options);
    chart.render();
  }
}
